import { IApplicationState } from '../../types/redux';
import { getBuilder } from '../newbuilding';

export const getBuilderChatDefaultMessage = (state: IApplicationState): string | undefined => {
  const chat = getBuilder(state).chat;

  if (chat.isEnabled) {
    return chat.defaultMessage;
  }

  return;
};
